import { FC, useMemo } from 'react';
import styles from './index.module.less';
import { formatPredictSale } from '../AreaSalesPredict/V2Predict';
import cs from 'classnames';

/**
 * @Description
 */
const FourNoSumPredictSale:FC<any> = ({
  data,
  className
}) => {

  // 预测营业额value
  const predictValue = useMemo(() => {
    return formatPredictSale(data);
  }, [data]);

  return (
    <div className={cs(styles.predict, className)}>
      <div className={styles.predictTitle}>
        <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/selectionmap/icon_turnover@3x.png`} className={styles.icon}/>
        <div className={styles.text}>{predictValue.title}</div>
      </div>
      <div className={styles.predictValue}>
        {predictValue?.val}
        <div className={styles.unit}>{predictValue?.unit}</div>
      </div>
    </div>
  );
};

export default FourNoSumPredictSale;
